import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import ContactForm from "./ContactForm";
import AppStoreButtons from "../../components/AppStoreButtons";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AppAccordionPage from "../faq-appPage";
import { pageMetadata } from "../../config/metadata";
import SEO from "../../Seo";
import { ourAppFAQ } from "../../config/faqSchema";
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const OnlineAppPage = () => {
  const metadata = pageMetadata.ourAppSeo;
  document.title = metadata.title;
  document.description = metadata.description;
   const contactFormRef = useRef(null);
    const setFormRef = (ref) => {
      contactFormRef.current = ref;
    };

// back to top button set
  useEffect(() => {
    const handleScroll = () => {
      const scrollToTopBtn = document.querySelector(".scrollToTopBtn");
      const rootElement = document.documentElement;

      if (rootElement.scrollTop >= 300) {
        scrollToTopBtn.classList.add("showBtn");
      } else {
        scrollToTopBtn.classList.remove("showBtn");
      }
    };

    const scrollToTop = () => {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    const scrollToTopBtn = document.querySelector(".scrollToTopBtn");
    scrollToTopBtn.addEventListener("click", scrollToTop);
    document.addEventListener("scroll", handleScroll);

    return () => {
      scrollToTopBtn.removeEventListener("click", scrollToTop);
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
     <SEO
        title={metadata.title}
        description={metadata.description}
        keywords={metadata.keywords}
        canonical={metadata.canonical}
        ogTitle={metadata.ogTitle}
        ogDescription={metadata.ogDescription}
        ogImage={metadata.ogImage}
        ogUrl={metadata.ogUrl}
        ogType={metadata.ogType}
        twitterCard={metadata.twitterCard}
        twitterTitle={metadata.twitterTitle}
        twitterDescription={metadata.twitterDescription}
        faqData={ourAppFAQ}
      />
     <div className="back-to-top">
        <button className="scrollToTopBtn">
          <img src="/img/new-home/back-to-top.png" alt="back-to-top" />
        </button>
      </div>

      <section className="parent-banner app-banner">
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 col-lg-6 order-change"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <h1>Prepare for SOF, IMO, NSO, NCO, IEO, IGKO, ISSO with Practido Olympiad Practice!</h1>
              <h2>Free Learning Starts Now!</h2>
              <p>Download App:</p>
              <div
                className="btn-wrapper btn-inline d-none"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <button type="btn" className="btn primary-btn">
                  Get Started
                </button>
                <button type="btn" className="btn blue-btn">
                  Already have an Account
                </button>
              </div>
              
              <div className="btn-wrapper btn-inline"><AppStoreButtons variant="white" /></div>
            </div>
            <div
              className="col-md-12 col-lg-6 right-item"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="img-box">
                <img
                  className="center-img"
                  src="/img/new-home/about.png"
                  alt="banner"
                />
                
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="student-vision">
        <div className="container">
          <h2>Master Olympiad Exams with India's Most<br/>Engaging Olympiad Practice App</h2>
          <p>Ready to shine in top Olympiad exams like SOF, IMO, NSO, NCO, IEO, IGKO, ISSO, and more?</p>
          <p>Practido - Olympiad Practice is your all-inclusive preparation hub for Maths Olympiad, Science Olympiad, English Olympiad, and Computer Olympiad for Classes 1 to 8. Our platform is built for smart preparation for exams, interactive learning, and consistent growth. Whether you're preparing for SOF Olympiad Practice, SilverZone Olympiad, Crest Olympiad, Hummingbird Olympiad, or other competitive exams, Practido ensures you learn smarter, revise better, and perform with confidence, making preparation for exams structured, fun, and result-driven.</p>                             
        </div>
      </section>

       <section className="parent-our-feature" id="features">
        <div className="container" data-aos="fade-up">
          <div
            className="container top-head"
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-duration="500"
          >
            <h2>
              Why Choose Practido - Olympiad Practice?
            </h2>
          </div>
          <div className="row aos-init aos-animate" data-aos="fade-up">
            <div
              className="col-md-6 aos-init"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <div className="img-box">
                <img src="/img/app-image/practice-image1.png" alt="Complete Olympiad" />
              </div>
            </div>
            <div
              className="col-md-6 aos-init"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <div className="content">
                <h3>Complete Olympiad Coverage</h3>
                <p>Strengthen core concepts in Mathematics, Science, English, and Computer with structured lessons, clear explanations, and class-wise practice modules enhanced with educational technology.</p>
                 <p><span className="bold">Ideal for:</span></p>
                 <ul className="my-0 bold-list">
                  <li>Maths Olympiad Preparation</li>
                  <li>Science Olympiad Practice</li>
                  <li>English Olympiad Preparation</li>
                  <li>Computer Olympiad Preparation</li>
                 </ul>
                  <p>Built to support students preparing for IMO Olympiad and Science Olympiad Foundation exams, the app simplifies preparation for exams with clarity and consistency.</p>
              </div>
            </div>
          </div>
          {/* row */}
          <div
            className="row order-change aos-init aos-animate"
            data-aos="fade-up"
          >
            <div
              className="col-md-6 aos-init"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <div className="content">
                <h3>Mock Tests & Exam-Level Practice</h3>
                <p>Get access to realistic mock tests, timed problem sets, sample questions, and pattern-based Olympiad questions.</p>
                <p><span className="bold">Perfect for refining speed, accuracy, and conceptual clarity for exams like:</span></p>
                <ul className="my-0 bold-list">
                  <li>SOF Olympiad</li>
                  <li>SilverZone Olympiad</li>
                  <li>Crest Olympiad</li>
                  <li>Hummingbird Olympiad</li>
                </ul>
                <p>These quizzes and problem sets function like a digital quiz test system, powered by smart gamification of learning tools to make preparation for exams more engaging.</p>
              </div>
            </div>
            <div
              className="col-md-6 aos-init"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <div className="img-box">
                <img src="/img/app-image/practice-image2.png" alt="Mock Tests" />
              </div>
            </div>
          </div>
          {/* row */}
          <div className="row aos-init aos-animate" data-aos="fade-up">
            <div
              className="col-md-6 aos-init"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <div className="img-box">
                <img src="/img/app-image/practice-image3.png" alt="Designed" />
              </div>
            </div>
            <div
              className="col-md-6 aos-init"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <div className="content">
                <h3>Designed for Classes 1 to 8</h3>
                <p>Every grade gets its own specially crafted content, ensuring young learners build strong foundations while advanced learners get the challenge they deserve.</p>
                <p>Ideal for mathematics olympiad learners and students preparing for various Science Olympiad Foundation events.</p>
              </div>
            </div>
          </div>
          {/* row */}
          <div
            className="row order-change aos-init aos-animate"
            data-aos="fade-up"
          >
            <div
              className="col-md-6 aos-init"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <div className="content">
                <h3>Smart, Personalised Learning</h3>
                <p><span className="bold">Right after every test, you receive:</span></p>
                <ul className="my-0 bold-list">
                  <li>Instant feedback</li>
                  <li>Strength & weakness analysis</li>
                  <li>Topic-wise performance breakdown</li>
                </ul>
                <p>So you can create a simple, focused study strategy, whether it's for Maths Olympiad, Science Olympiad, English Olympiad, Computer Olympiad, or any IMO Olympiad preparation path.</p>
                <p>Helps students learn English, solve mathematics olympiad patterns, and improve Science Olympiad Foundation readiness.</p>
              </div>
            </div>
            <div
              className="col-md-6 aos-init"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <div className="img-box">
                <img src="/img/app-image/practice-image4.png" alt="Personalised Learning" />
              </div>
            </div>
          </div>
          {/* row */}
          <div className="row aos-init aos-animate" data-aos="fade-up">
            <div
              className="col-md-6 aos-init"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <div className="img-box">
                 <img src="/img/app-image/practice-image5.png" alt="Offline Study" />
              </div>
            </div>
            <div
              className="col-md-6 aos-init"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <div className="content">
                <h3>Offline Study (PDF Downloads)</h3>
                <p>Prefer studying without screens?</p>
                <p>Download Olympiad-themed mock tests in PDF format, practice anytime, anywhere, and revisit concepts at your own pace.</p>
                <p>Perfect for students practicing sample questions for mathematics olympiad or school-level preparation for exams.</p>
              </div>
            </div>
          </div>
          {/* row */}
          <div
            className="row order-change aos-init aos-animate"
            data-aos="fade-up"
          >
            <div
              className="col-md-6 aos-init"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <div className="content">
                <h3>Fun, Engaging & Reward-Driven</h3>
                <p>Olympiad prep doesn't have to feel stressful.</p>
                <p>With fun challenges, reward badges, streaks, and interactive tools, Practido keeps children excited to learn, even for the toughest Olympiad subjects.</p>
                <p>Our gamification of learning methods help students learn English, sharpen reasoning, and stay consistent throughout their preparation for exams.</p>
              </div>
            </div>
            <div
              className="col-md-6 aos-init"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <div className="img-box">
                 <img src="/img/app-image/practice-image6.png" alt="Reward-Driven" />
              </div>
            </div>
          </div>
          {/* row */}
         
        </div>
      </section>
      <div className="tab-section overflow-hidden">
        <div className="section sky-blue-back mb-0 feature-wrapper parent-challenge blue-section">
          <div className="container">
            <div className="feature-box row aos-animate pd0 order-change">
              <div
                className="col-md-12 col-offset-1 col-lg-6 para-box"
                data-aos="fade-right"
              >
                <h2 className="left">Key Features of Practido - Olympiad Practice</h2>
                <p className="left">
                  Dedicated modules for Maths, Science, English, and Computer Olympiads Support for major competitions: SOF Olympiad, Hindustan Olympiad, SilverZone Olympiad, Crest Olympiad, Hummingbird Olympiad Class-specific learning journeys from Class 1 to 8 Safe, child-friendly environment for independent practice Healthy peer competition with friends through leaderboard features Ideal for students following Science Olympiad Foundation pathways, mathematics olympiad aspirants, and competitive quiz test lovers</p>
                <h4>Free Learning Starts Now!</h4>
                <p className="left mb-4">Download App:</p>
                <div className="btn-wrapper btn-inline">
                 <AppStoreButtons variant="white" />
                 </div>
              </div>
              <div
                className="col-md-12 col-lg-5 center"
                data-aos="fade-left"
              >
                <img
                  className="feature-img"
                  src="/img/student-home/feature-5.webp"
                  alt="feature"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="parent-practido">
        <div className="container">
          <div className="container aos-animate" data-aos="fade-up">
            <div
              className="head"
              data-aos="fade-up"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              <h2>Achieve Your Olympiad Goals with Confidence</h2>
              <p className="text-center">Download Practido Olympiad Practice and start your journey towards becoming an Olympiad champion. Whether it's SOF, SilverZone, Crest, or Hummingbird, we help you learn with clarity, practice with purpose, and perform with excellence.</p>
              <p className="text-center mb-4">Be consistent. Be confident. Be Olympiad-ready with Practido, your trusted Olympiad companion for powerful preparation for exams, sample questions, mathematics olympiad learning, Science Olympiad Foundation prep, and quiz test mastery.</p>
              <div className="text-center mt-4 d-flex justify-content-center">
                <div className="btn-wrapper btn-inline"><AppStoreButtons variant="white" /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="faq-main-section faq-container">
        <div className="faq-data">
          <div className="container">
            <h3>Frequently Asked Questions</h3>       
            <div className="update-faq">
              <AppAccordionPage></AppAccordionPage>
            </div>
          </div>
        </div>
      </section>
      <ContactForm contactFormRef={setFormRef} />
    </>
  );
};

export default OnlineAppPage;
